import * as React from 'react';
import cx from 'classnames';

export interface CKTagProps {
  className?: string;
}

export const CKTag: React.FC<CKTagProps> = ({ children, className }) => {
  const tagClass = cx('ck-tag', className);
  return <div className={tagClass}>{children}</div>;
};
